import { graphql } from "@apollo/react-hoc"
import { defaultState } from "./helpers/defaults"
import BENCHMARK_SETTINGS_QUERY from "./BenchmarkSettingsQuery.gql"

const withBenchmarkSettings = graphql(BENCHMARK_SETTINGS_QUERY, {
  props: ({ data: { currentUser, industries = [], loading, refetch } }) => ({
    benchmarkSettingsLoading: loading,
    benchmarkSettings: currentUser
      ? currentUser.benchmarkSettings
      : defaultState,
    industries,
    benchmarkSettingsRefetch: refetch,
  }),
})

export { withBenchmarkSettings }
